module.exports = __webpack_public_path__ + "static/media/mail.035a5b27.svg";